import { PropsWithChildren } from 'react';
import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { useIsExternalUser } from '../../helpers/useIsExternalUser';
import { ExternalUserRouteGuard } from './ExternalUserRouteGuard';
import { LegacyAppShell } from './LegacyAppShell';
import { AppShell } from './sidebar/AppShell';

/** User feature flag that goes back to the original sidebar for now. */
export const SIDEBAR_LEGACY_FLAG = 'sidebar-legacy';

/**
 * The page frame around every route: the BUI sidebar (sidebar/AppShell) by
 * default, or the original sidebar in LegacyAppShell for people who turned on
 * `sidebar-legacy`.
 */
export const Root = ({ children }: PropsWithChildren<{}>) => {
  const featureFlags = useApi(featureFlagsApiRef);
  const { loading, isExternal } = useIsExternalUser();

  // Pick the frame once we know who this is: switching it afterwards would
  // remount the page.
  if (loading) return null;
  // External users keep the reduced legacy menu.
  if (!featureFlags.isActive(SIDEBAR_LEGACY_FLAG) && !isExternal) {
    return (
      <AppShell>
        <ExternalUserRouteGuard />
        {children}
      </AppShell>
    );
  }

  return <LegacyAppShell>{children}</LegacyAppShell>;
};
